import styled, { css } from "styled-components";

const StyledArticleContent = styled.div`
  position: relative;
  font-family: var(--font-serif);
  font-weight: 300;
  max-width: var(--text-max-width);
  margin: 3em auto 0;
  line-height: 1.6;
  z-index: 1;
  ${props => props.textColor === "dark" && css`
    color: var(--theme-text-against-light);
  `}
  //color: ${props => props.textColor === "light" ? `var(--theme-text-against-dark)` : `var(--theme-text-against-light)`};
  font-feature-settings: "lnum";
  p {
    font-size: var(--text-size);
    ${props => props.textSizeMultiplier && css`
      font-size: calc(var(--text-size) * ${props.textSizeMultiplier});
    `}
    margin: 1.363636em 0;
    &.has-drop-cap:not(:first-child) {
      margin-top: calc(1.363636em * 2);
    }
    &.has-drop-cap::first-letter {
      float: left;
      //font-size: 3.3em;
      font-size: 3.4em;
      //padding-top: 0.15em;
      padding-top: 0.17em;
      padding-right: 0.1875em;
      line-height:0.54;
      //opacity: 0.5;
    }
  }
  
  a {
    text-decoration-line: underline;
    text-decoration-thickness: 0.75px;
    text-underline-offset: 0.1em;
    text-decoration-color: var(--theme-heavy-border-against-dark);
    transition: opacity 0.2s ease;
  }
  .can-hover & a:hover,
  a:active {
    opacity: 0.5;
  }

  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    margin: var(--text-size) auto 0;
    text-align: center;
  }
  h2 {
    font-size: var(--text-size-large);
  }
  h3 {
    font-size: var(--text-size-medium);
  }
  /*
  h2 + p,
  h3 + p {
    margin-top: 0.5em;
  }
  */

  .wp-block-image figcaption {
    font-family: var(--font-sans);
    font-size: 0.875em;
    opacity: 0.7;
    text-align: left;
    margin-top: 0.625em;
    line-height: 1.3;
  }

  p small {
    font-size: 1em;
    font-variant-caps: small-caps;
    font-feature-settings: "smcp";
    font-weight: 500;
  }

  .wp-block-pullquote blockquote,
  .pull-quote {
      position: relative;
      padding: 1em 0;
      margin: calc(2 * var(--text-size)) auto;
      &::before,
      &::after {
        content: '';
        display: block;
        width: 25%;
        margin: 0 auto;
        height: 2px;
        background-color:  currentColor;
        opacity: 0.3;
        border-radius: 2px;
      }
      &::before {
        margin-bottom: calc(2.5 * var(--text-size));
      }
      &::after {
        margin-top: calc(2.625 * var(--text-size));
      }
      p {
        font-size: 1.5em;
        text-align: center;
        line-height: 1.4;
        max-width: 100%;
        font-weight: normal;
        &:first-of-type {
          margin-top: 0;
        }
        &:last-of-type {
          margin-bottom: 0;
        }
      }
      @media ( min-width: 48em ) {
        margin-right: -6em;
        margin-left: -6em;
        p {
          font-size: 2.5em;
          line-height: 1.3;
        }
      }
    }

  hr {
    border: 0;
    margin: 3em auto 3.375em;
    height: 2px;
    border: 0;
    width: 25%;
    background-color:  #d3dce6;
  }

  /******************************************************
  * Embeds
  *******************************************************/
  .wp-block-embed {
    width: 100%;
  }
  .wp-block-embed iframe {
    display: block;
    width: 100%;
  }
  .wp-block-embed.is-type-video {
    position: relative;
  }
  .wp-block-embed .wp-block-embed__wrapper {
    position: relative;
  }
  .wp-block-embed.is-type-video .wp-block-embed__wrapper {
    height: 0;
    padding: 0;
  }
  .wp-block-embed.wp-embed-aspect-16-9 .wp-block-embed__wrapper {
    padding-bottom: 56.25%;
  }
  .wp-block-embed.wp-embed-aspect-4-3 .wp-block-embed__wrapper {
    padding-bottom: 75%;
  }
  .wp-block-embed.wp-embed-aspect-16-9 .wp-block-embed__wrapper iframe,
  .wp-block-embed.wp-embed-aspect-4-3 .wp-block-embed__wrapper iframe,
  .wp-block-embed-youtube .wp-block-embed__wrapper iframe {
    position: absolute;
    display: block;
    height: 100%;
    width: 100%;
  }

  .wp-block-image,
  .wp-block-embed,
  .post-video {
    max-width: var(--text-max-width);
    margin: calc(2 * var(--text-size)) auto;
  }

  .wp-block-image img {
    margin-right: auto;
    margin-left: auto;
    display: block;
  }

  /******************************************************
  * Alignments
  *******************************************************/
  .aligncenter,
  .wp-block-image .aligncenter .gatsby-image-wrapper {
    display: block;
    margin-right: auto;
    margin-left: auto;
    text-align: center;
  }
  .alignwide .wp-block-image .gatsby-image-wrapper,
  .alignfull .wp-block-image .gatsby-image-wrapper {
    width: 100% !important;
  }
  .inline-gatsby-image-wrapper, 
  .inline-gatsby-image-wrapper span {
    display: block;
  }

  //.alignwide,
  .alignfull {
    position: relative;
    width: 100vw;
    left: 50%;
    margin-left: -50vw;
  }

  @media ( min-width: 48em ) {
    .alignwide {
      position: relative;
      width: 70vw;
      margin-left: -35vw;
      max-width: 100vw;
      left: 50%;
    }
  }

  /******************************************************
  * Block: Buttons
  *******************************************************/
  .wp-block-buttons {
    display: flex;
  }
  .wp-block-buttons .wp-block-button {
    margin-right: 1em;
  }
  
  /******************************************************
  * Block: Gallery
  *******************************************************/
  .blocks-gallery-grid {
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .gallery-varied .blocks-gallery-grid {
    display: grid;
    grid-gap: 0.6em;
    grid-template: auto / repeat(3, calc(33% - 0.2em));
  }

  .gallery-varied .blocks-gallery-grid .blocks-gallery-item figure {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 70%;
  }
  .gallery-varied .blocks-gallery-grid .blocks-gallery-item figure .gatsby-image-wrapper {
    position: absolute !important;
    width: 100% !important;
    height: 100%;
  }
  .gallery-varied .blocks-gallery-grid .blocks-gallery-item:nth-of-type(4n + 1) {
    grid-column: auto / span 3;
  }


  > .wp-block-gallery {
    position: relative;
    width: 100vw;
    left: 50%;
    margin: 1.5em 0 1.5em -50vw;
    background-color: var(--theme-background-light);
    white-space: nowrap;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: thin;
    scrollbar-color: #c6c6c6 var(--theme-background-light);
  }
  > .wp-block-gallery::-webkit-scrollbar {
    width: 0.6875em;
    height: 0.6875em;
  }
  > .wp-block-gallery::-webkit-scrollbar-track {
    background: var(--theme-background-light);
  }
  > .wp-block-gallery::-webkit-scrollbar-thumb {
    background-color: #c6c6c6;
    border: 0.25em solid var(--theme-background-light);
    border-width: 0.25em 0.2em 0.25em 0.25em;
  }

  > .wp-block-gallery .blocks-gallery-grid {
    position: relative;
    list-style: none;
    margin: 0;
    padding: 0;
    padding: 1.5em 1.5em 1em;
  }
  > .wp-block-gallery .blocks-gallery-grid .blocks-gallery-item {
    position: relative;
    display: inline-block;
    vertical-align: top;
    width: 100%;
    max-width: 30em;
    width: clamp(80vw, 100%, 30em);
  }
  > .wp-block-gallery .blocks-gallery-grid .blocks-gallery-item:not(:last-of-type) {
    margin-right: 0.75em;
  }
  > .wp-block-gallery .blocks-gallery-grid .blocks-gallery-item:last-of-type {
    margin-right: 1.5em;
  }
  > .wp-block-gallery .blocks-gallery-grid .blocks-gallery-item figure {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 70%;
  }
  > .wp-block-gallery .blocks-gallery-grid .blocks-gallery-item figure .gatsby-image-wrapper {
    position: absolute !important;
    width: 100% !important;
    height: 100%;
  }
  @media ( min-width: 36em ) {
  }



  /******************************************************
  * Block: Media & Text
  *******************************************************/
  .wp-block-media-text.alignwide {
    width: 100%;
    left: auto;
    margin-left: auto;
  }
  @media ( min-width: 48em ) {
    .wp-block-media-text {
      display: grid;
      grid-template: 1fr / 40% 60%;
      grid-gap: 1.5em;
    }
    .wp-block-media-text.is-vertically-aligned-center {
      align-items: center;
    }
  }


  .dev-hide {
    display: none !important;
  }

`;

export default StyledArticleContent;